




























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";

const retreatCouponModule = namespace("retreatCoupon");

@Component({
  components: {}
})
export default class Search extends Vue {
  value: any = "";

  mounted() {
    (this as any).$wechartfunc();
    this.setActive();
  }

  setActive() {
    this.$store.commit("retreatCoupon/setSelectStep", 0);
  }

  async handleSearchClick() {
    if (this.value == "") {
      Toast("请输入卡号");
      return false;
    }
    this.$router.push({
        path: `/resetCard/returnList`,
        query: {
          sancode: this.value,
          type: "1"
        }
      });
      return
    const { error, success } = await this.$store.dispatch(
      "retreatCoupon/memberDetail",
      {
        searchText: this.value,
        searchType: 1
      }
    );
    if (success) {
      this.$router.push({
        path: `/writeoffCard/cardList`,
        query: {
          sancode: this.value,
          type: "1"
        }
      });
    } else {
      const { error, success } = await this.$store.dispatch(
        "retreatCoupon/memberDetail",
        {
          searchText: this.value,
          searchType: 3
        }
      );
      if (success) {
        this.$router.push({
          path: `/retreatCoupon/couponList`,
          query: {
            sancode: this.value,
            type: "3"
          }
        });
      } else {
        Toast(error.msg);
      }
    }
  }
}
